export const colors = {
  accent: '#2f71cd',
  bgLight: '#edede5',
  bgDark: '#ede8cd',
};

export const wallpaperUrl = 'https://i.imgur.com/smBYDRH.png'; // replace with local asset when ready
